import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { IIdName, IChangeCallback } from '../../_entities';

@Component({
    selector: 'delete-dialog',
    template: require('./delete-dialog.template.html')
})
export class DeleteDialogComponent {

    @ViewChild('modal') public childModal: ModalDirective;

    @Output() notifyConfirmed: EventEmitter<any> = new EventEmitter<any>();

    @Input() title: string;

    @Input() nameProperty: string = "name";

    @Input() messageTemplate: string;

    deleting: boolean = false;

    errorMessage: string = "";

    entity: any;

    message: string = "";

    show(item: any, $event: IChangeCallback<any>): void {
        //resolve any initial event that opened this window
        if ($event) {
            $event.resolve();    
        }

        console.dir(item);

        this.entity = item;
        this.message = item && item[this.nameProperty] ? this.messageTemplate.replace("#", item[this.nameProperty]) : "(unnamed)";
        this.errorMessage = "";

        this.childModal.show();
    }

    onHide(): void {
        this.childModal.hide();
    }

	onDelete(): void {
		console.log("deleting");
        this.deleting = true;
        this.notifyConfirmed.emit({
            id: this.entity.id,
            oldValue: this.entity,
            resolve: () => {
                this.deleting = false;
                this.childModal.hide();
            },
            reject: (message: string) => {
                this.deleting = false;
                this.errorMessage = message;
            }
        });
	}

	get prettyErrorMessage() {
		if (typeof this.errorMessage === 'string') {
			var firstSentence = this.errorMessage.split('\.')[0];
			return firstSentence;
		} else {
			return this.errorMessage;
		}


	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/delete-dialog.component.ts